<template>
  <v-expansion-panels :value="0">
    <v-expansion-panel>
      <v-expansion-panel-header>
        <b>QR коды</b>
      </v-expansion-panel-header>

      <v-expansion-panel-content>
        <BListFilter
          v-model="searchForm"
          label="Поиск..."
          :skeleton="isLoading"
          dense
          class="my-2"
          @change="onChangeDebounced"
        />
        <BTable
          :list="list"
          :headers="headers"
          :actions="actions"
          :loading="isLoading"
          :pagination="pagination"
          @change:pagination="onChangePagination"
          @action:delete="onDelete"
          @action:download:variants="(item, callback) => onDownload(item.variants_file_sha1_sum, callback)"
          @action:download="(item, callback) => onDownload(item.criteria_file_sha1_sum, callback)"
        />
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import BTable from '@/components/common/BTable.vue'
import BListFilter from '@/components/forms/BListFilter.vue'

import { VPRQRCodesApi } from '@/api/resources'
import { downloadLinkByGet } from '@/helpers/downloadBlob'
import { DELETE, DOWNLOAD } from '@/helpers/enums/table-actions'
import { createModalConfirm } from '@/helpers/createModalConfirm'

const DEFAULT_PARAMS = {
  page: 1,
  per_page: 10,
  count: 0,
}


export default {
  name: 'QrCodesTable',
  components: {
    BTable,
    BListFilter,
  },
  props: {
    vprPublicationPartId: {
      type: Number,
      required: true,
    },
  },
  data: () => ({
    isLoading: false,
    list: [],
    searchForm: {
      search: null,
    },
    pagination: { ...DEFAULT_PARAMS },
    headers: [
      {
        text: 'Логин ОО',
        value: 'vpr_user',
        sortable: false,
      },
      {
        text: 'Часть',
        value: 'vpr_publication_part_position',
        sortable: false,
      },
      {
        text: 'Вариант',
        value: 'vpr_variant_position',
        sortable: false,
      },
      {
        text: 'Оригинальный вариант',
        value: 'vpr_original_variant_number',
        sortable: false,
      },
      {
        text: 'Код',
        value: 'vpr_qr_code',
        sortable: false,
      },
    ],
    actions: [
      {
        action: 'download:variants',
        tooltip: 'Скачать варианты',
        icon: 'mdi-download-outline',
        getFilter: (v) => !!v.variants_file_sha1_sum,
      },
      {
        ...DOWNLOAD,
        tooltip: 'Скачать критерии',
        getFilter: (v) => !!v.criteria_file_sha1_sum,
      },
      {
        ...DELETE,
        tooltip: 'Удаление комплекта КИМ и Критериев из системы Коллектор',
      },
    ],
  }),
  methods: {
    asyncData() {
      const params = { ...this.pagination }
      this.onGetData(params)
    },
    onRefresh() {
      this.searchForm.search = null
      this.pagination.page = 1
      this.onGetData()
    },
    async onGetData(params) {
      if (!this.vprPublicationPartId) {
        return
      }

      this.isLoading = true
      const api = new VPRQRCodesApi()
      try {
        const payload = {
          ...this.pagination,
          ...params,
          vpr_publication_part_id: this.vprPublicationPartId,
        }
        if (this.searchForm.search) {
          payload.search = this.searchForm.search
        } else {
          delete payload.search
        }
        const result = await api.getAll(payload)
        this.list = result.data
        this.pagination.page = payload.page
        this.pagination.count = result.meta.count
        if (result.meta?.count > 0) {
          this.$emit('received')
        }
      } catch (e) {
        this.$notice.errors(e)
      } finally {
        this.isLoading = false
      }
    },
    onChangePagination(options) {
      this.pagination.page = options.page || DEFAULT_PARAMS.page
      this.pagination.per_page = options.per_page || DEFAULT_PARAMS.per_page

      return this.onGetData()
    },
    onChangeDebounced() {
      this.onGetData({ page: 1 })
    },
    async onDelete(item) {
      const propsData = {
        titleText: 'Подтверждение удаления',
        mainText: 'Вы удаляете для выбранной ОО сгенерированный в системе Коллектор комплект КИМ и Критериев. Удаление произойдет для обоих вариантов. Если комплект был перенесен в публикацию ЛК, то там его необходимо удалить вручную. Автоматического запуска удаления архива в хранилище ЛК не произойдет.',
        cancelBtn: 'Отмена',
        successBtn: 'ОК',
        success: false,
        action: () => this.onDeleteConfirm(item),
      }

      const modal = await createModalConfirm(this, propsData)
      return modal.open().finally(() => {
        modal.close()
        this.onGetData()
      })
    },
    onDeleteConfirm(item) {
      const api = new VPRQRCodesApi()
      return api.delete(item.vpr_qr_code_id)
    },
    onDownload(sha1, callback) {
      const unwatch = callback?.()
      try {
        const path = `${process.env.VUE_APP_COLLECTOR_API_URL}/api/v1/files/${sha1}/download`
        downloadLinkByGet(
          path,
          false,
          { isNewTab: false },
          { headers: { 'X-Access-Token': process.env.VUE_APP_COLLECTOR_API_TOKEN } },
        )
      } catch (e) {
        this.$notice.errors(e)
      } finally {
        unwatch?.()
      }
    },
  },
}
</script>
